// extracted by mini-css-extract-plugin
export default {"toolbar":"UserEdit_toolbar__gc2L3"};